export const AUTH_LOCAL_STORAGE_KEY = '360_AUTH_TOKEN';

const getAuth = (): string | undefined => {
  if (!localStorage) {
    return;
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const token = JSON.parse(lsValue);
    if (token) {
      // verificar facilmente a expiração do auth_token
      return token;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
  }
};

const setAuth = (token: string) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(token);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
  }
};

export const authHelper = { AUTH_LOCAL_STORAGE_KEY, getAuth, removeAuth, setAuth };
